import { EligibilityCheckResponse, EligibilityCheckResult, EligibilityCheckResultWithPCP, InsuranceEligibility, PlanStatusCode, ServiceTypeCode } from './types';

/**
 * https://expressable.slack.com/archives/C086VL2P4M6/p1736455905499809
 * insuranceEligibility is active
 * in plan network indicator is Y for the speech therapy benefit
 * The benefitsInformation.code is any (as long as benefitAmount is 0 (exempt from patient responsibility))
 */
export const isLeadEligible = (eligibilityInformation: EligibilityCheckResponse): EligibilityCheckResultWithPCP => {
  // Extract and format PCP information from the response
  const pcpData = eligibilityInformation.eligibilityDetails?.benefitsInformation?.primaryCareProvider;
  let pcp: EligibilityCheckResultWithPCP['pcp'] = null;

  if (pcpData) {
    const entity = pcpData.benefitsRelatedEntity;
    const phoneContact = entity.contactInformation?.contacts.find(
      contact => contact.communicationMode === 'Telephone'
    );
    const faxContact = entity.contactInformation?.contacts.find(
      contact => contact.communicationMode === 'Facsimile'
    );

    pcp = {
      name: entity.entityName,
      firstName: entity.entityFirstname,
      middleName: entity.entityMiddlename,
      phone: phoneContact?.communicationNumber,
      fax: faxContact?.communicationNumber,
      npi: entity.entityIdentificationValue,
      address: entity.address ? {
        address1: entity.address.address1,
        city: entity.address.city,
        state: entity.address.state,
        postalCode: entity.address.postalCode,
      } : undefined,
    };
  }

  // 1. Check if the insurance eligibility is active
  if (eligibilityInformation.insuranceEligibility !== InsuranceEligibility.Active) {
    return {
      status: EligibilityCheckResult.INACTIVE,
      pcp,
    };
  }
  // 2. Check for service type codes in planStatus for speechTherapy and generalHealth
  const speechTherapy = eligibilityInformation.eligibilityDetails?.planStatus?.speechTherapy?.find(status => status?.serviceTypeCodes?.includes(ServiceTypeCode.SPEECH_THERAPY));
  const generalHealth = eligibilityInformation.eligibilityDetails?.planStatus?.generalHealth?.find(status => status?.serviceTypeCodes?.includes(ServiceTypeCode.GENERAL_HEALTH));

  // 3. If either service exists but is not active, return INACTIVE
  // https://www.stedi.com/docs/healthcare/benefit-response#active-and-inactive-coverage
  if ((speechTherapy && speechTherapy.statusCode === PlanStatusCode.INACTIVE) || 
      (generalHealth && generalHealth.statusCode === PlanStatusCode.INACTIVE)) {
    return {
      status: EligibilityCheckResult.INACTIVE,
      pcp,
    };
  }

  // 4. Determine eligibility based on priority: speechTherapy > generalHealth
  if (speechTherapy?.statusCode === PlanStatusCode.ACTIVE ||
      generalHealth?.statusCode === PlanStatusCode.ACTIVE) {
    return {
      status: EligibilityCheckResult.IN_NETWORK,
      pcp,
    };
  }

  return {
    status: EligibilityCheckResult.ERROR,
    pcp,
  };
};
